import React, { Component } from "react";
import Slider from "react-slick";
// import NavDots from '~/js/components/NavDots';
// import MagicSliderDots from 'react-magic-slider-dots';

import SliderArrow from "~/js/components/SliderArrow";

class ResortCard extends Component {
  constructor(props) {
    super(props);
    this.abortController = new window.AbortController();
  }
  render() {
    const { resort, slideImages, staticResortInfo, sliderMode } = this.props;
    const awards = sandals_app.page.awards[resort.rstCode];
    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      arrows: true,
      nextArrow: <SliderArrow classNames="slider-arrow slider-arrow-next" />,
      prevArrow: <SliderArrow classNames="slider-arrow slider-arrow-prev" />,
      lazyLoad: true,
      // appendDots: dots => {
      //   return <MagicSliderDots dots={dots} numDotsToShow={5} dotWidth={30} />;
      // },
    };

    // const renderHTML = rawHTML =>
    //     React.createElement('p', {
    //         dangerouslySetInnerHTML: { __html: rawHTML },
    //     });

    const { moods, mainFeatures } = this.props;
    const currentResort = resort.rstCode;
    const features = mainFeatures[currentResort]
      ? mainFeatures[currentResort].mainFeatures
      : "";
    const resortObject = staticResortInfo.filter((resort) => {
      if (resort.rstCode === currentResort) {
        return resort;
      }
    })[0];
    const content = currentResort === 'SDR'? (<React.Fragment><span className="sdr-arrivals">FOR ARRIVALS <br/>STARTING</span><span className="date"><strong><br/>MAY 24, 2023</strong></span></React.Fragment>): 'NOW OPEN';
    if (resortObject !== undefined) {
      return (
        <div
          className={`resort-card fix-dots col-xs-12 ${
            sliderMode ? "" : "no-slider"
          }`}
        >
          {sliderMode && window.innerWidth < 992 ? (
            <img
              src={`${resortObject.resortMainImg}.jpg`}
              alt={resortObject.name}
            />
          ) : (
            <Slider {...settings}>
              {slideImages.map((img, index) => {
                return <img key={index} src={img.src} alt={img.title} />;
              })}
            </Slider>
          )}
          <div className="text-box">
            <div className="resort-info">
              <h3 className="resort-name">Sandals {resortObject.name}</h3>
              <span className="location">
                {resortObject.city} - {resortObject.country}
              </span>
              <p className="features-title">Main Features</p>
              <p className="features">• {features && features.join(" • ")}</p>
              <div className="rooms-mood-container">
                <a
                  href={`${resortObject.link}rooms-suites/`}
                  className="view-rooms"
                >
                  View Rooms
                  <i
                    aria-label="rooms link"
                    className="ic ic-link-arrow"
                    tabIndex="0"
                  />
                </a>
                <span className="resort-mood">
                  resort mood:{" "}
                  <span className="mood-types">
                    {moods && moods.join(", ")}
                  </span>
                </span>
              </div>
              <div className="view-resort-container">
                <a className="view-resort" href={resortObject.link}>
                  View Resort
                </a>
              </div>
            </div>
            <div className={`award-reviews ${currentResort === 'SCR' ? 'scr' : ''} ${currentResort === 'SDR' ? 'sdr' : ''}`}>
              <div className={currentResort ==='SDR' ?'sdr-awards':'awards'}>
                {awards ? awards.map((award, i) => {
                  return (
                    <div key={`award-${resort.rstCode}-${i}`} className="award">
                      <img
                        src={award.image}
                        alt={award.alt}
                        className="award-img"
                      />
                      <span className="award-name">
                        {award.text.replace(/<.*>/g, "")}
                      </span>
                    </div>
                  );
                }) :
                  <div className="for-arrivals">
                    <p>
                      <span className="arrivals">{content}</span>
                    </p>
                  </div>
                }
              </div>
            </div>
            {/* {typeof rates[resortObject.rstCode] === 'undefined' ? (
                             ''
                            ) : (
                            <div className="rate">
                                <small>
                                    All-Inclusive
                                    <br /> Vacations from
                                </small>
                                <span className="price">${rates[resortObject.rstCode].lowest.avgRate}</span>
                                <small>
                                    {' '}
                                    PP/PN
                                    <br /> (USD)
                                </small>
                            </div>
                            )}*/}
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}

ResortCard.defaultProps = {
  sliderMode: false,
};

export default ResortCard;
